// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.idle_reason_item {
    padding: 16px;
    background: white;
    box-shadow: 0px -2px 2px 0px #efefef;
    margin: 10px 0;
    position: relative;
    border-radius: 5px;
    border: 1px solid orange;
    display: flex;
    justify-content:flex-start;
    align-items: center;
}
.idle_reason_list, .idle_reason_page, .machine_lmw_page {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    width: 100%;
}

.icons {
    width: 40px;
    height: 40px;
    background: #d4d4d4;
    border-radius: 50%;
    position: relative;
    min-width: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
     font-size: 18px !important;
    font-weight: 600;
}

.icon.icon-text {
    font-size: 18px;
    font-weight: 600;
}

.reason-text {
    color: black;
    margin: 0;
    font-size: 16px;
    font-weight: 400;
    line-height: 30px;
}

.user_action {
    display: flex;
    align-items: center;
}

.user_action li {
    display: inline; /* Optional: make them horizontal */
    margin-left: 5px; /* Space between icons */
}

.user_action li a {
    display: inline-block; /* Ensure the links are inline */
    text-decoration: none; /* Remove underline from links */
    border: none;
}

.user_action li a i { /* Targeting Font Awesome icons */
    font-size: 16px;
    color: grey; /* Default icon color */
    transition: color 0.3s ease; /* Smooth color transition on hover */
}
.user_action {
    -webkit-display: flex;
    -moz-display: flex;
    -ms-display: flex;
    -o-display: flex;
    display: flex;
    -moz-align-items: center;
    -ms-align-items: center;
    -o-align-items: center;
    align-items: center;
    position: absolute;
    top: 15px;
    right: 5px;
}
/* Hover state for icons */
.user_action li a:hover i {
    color: #000000; /* Change color on hover */
}

/* Additional styles */


.as-add {
    text-align: right;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.idle_reason_item {
    padding: 16px;
    width: 30%;
    background: white;
    box-shadow: 0px -2px 2px 0px #efefef;
    margin: 0 5px 10px 0;
    position: relative;
    border-radius: 5px;
    border: 1px solid orange;
    gap: 10px;
}

 .idle_reason_item h3 {
    color: black;
    margin: 0;
    font-size: 16px;
    font-weight: 400;
    line-height: 30px;
}

 .idle_reason_item .machine_no {
    color: #ccc;
    position: absolute;
    right: 10px;
    bottom: 2px;
    font-size: 20px;
    font-weight: 400;
}



icon-text {
    position: absolute;
    top: 30%;
    left: 50%;
    transform: translateX(-50%);
    font-size: 25px !important;
    font-weight: 600;
    color:black;
}

/* Responsive design */
@media screen and (max-width: 768px) {
    .container {
        padding: 10px;
        margin: 10px;
    }

    .idle_reason_item {
        flex-direction: column;
        align-items: flex-start;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/Pages/Machines/machine.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,iBAAiB;IACjB,oCAAoC;IACpC,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,wBAAwB;IACxB,aAAa;IACb,0BAA0B;IAC1B,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;KACtB,0BAA0B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,eAAe,EAAE,mCAAmC;IACpD,gBAAgB,EAAE,wBAAwB;AAC9C;;AAEA;IACI,qBAAqB,EAAE,gCAAgC;IACvD,qBAAqB,EAAE,gCAAgC;IACvD,YAAY;AAChB;;AAEA,sBAAsB,iCAAiC;IACnD,eAAe;IACf,WAAW,EAAE,uBAAuB;IACpC,2BAA2B,EAAE,qCAAqC;AACtE;AACA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;IACb,wBAAwB;IACxB,uBAAuB;IACvB,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;IACT,UAAU;AACd;AACA,0BAA0B;AAC1B;IACI,cAAc,EAAE,0BAA0B;AAC9C;;AAEA,sBAAsB;;;AAGtB;IACI,iBAAiB;IACjB,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,UAAU;IACV,iBAAiB;IACjB,oCAAoC;IACpC,oBAAoB;IACpB,kBAAkB;IAClB,kBAAkB;IAClB,wBAAwB;IACxB,SAAS;AACb;;CAEC;IACG,YAAY;IACZ,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;CAEC;IACG,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;;;;AAIA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,2BAA2B;IAC3B,0BAA0B;IAC1B,gBAAgB;IAChB,WAAW;AACf;;AAEA,sBAAsB;AACtB;IACI;QACI,aAAa;QACb,YAAY;IAChB;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;AACJ","sourcesContent":[".idle_reason_item {\n    padding: 16px;\n    background: white;\n    box-shadow: 0px -2px 2px 0px #efefef;\n    margin: 10px 0;\n    position: relative;\n    border-radius: 5px;\n    border: 1px solid orange;\n    display: flex;\n    justify-content:flex-start;\n    align-items: center;\n}\n.idle_reason_list, .idle_reason_page, .machine_lmw_page {\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    width: 100%;\n}\n\n.icons {\n    width: 40px;\n    height: 40px;\n    background: #d4d4d4;\n    border-radius: 50%;\n    position: relative;\n    min-width: 40px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n     font-size: 18px !important;\n    font-weight: 600;\n}\n\n.icon.icon-text {\n    font-size: 18px;\n    font-weight: 600;\n}\n\n.reason-text {\n    color: black;\n    margin: 0;\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 30px;\n}\n\n.user_action {\n    display: flex;\n    align-items: center;\n}\n\n.user_action li {\n    display: inline; /* Optional: make them horizontal */\n    margin-left: 5px; /* Space between icons */\n}\n\n.user_action li a {\n    display: inline-block; /* Ensure the links are inline */\n    text-decoration: none; /* Remove underline from links */\n    border: none;\n}\n\n.user_action li a i { /* Targeting Font Awesome icons */\n    font-size: 16px;\n    color: grey; /* Default icon color */\n    transition: color 0.3s ease; /* Smooth color transition on hover */\n}\n.user_action {\n    -webkit-display: flex;\n    -moz-display: flex;\n    -ms-display: flex;\n    -o-display: flex;\n    display: flex;\n    -moz-align-items: center;\n    -ms-align-items: center;\n    -o-align-items: center;\n    align-items: center;\n    position: absolute;\n    top: 15px;\n    right: 5px;\n}\n/* Hover state for icons */\n.user_action li a:hover i {\n    color: #000000; /* Change color on hover */\n}\n\n/* Additional styles */\n\n\n.as-add {\n    text-align: right;\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.idle_reason_item {\n    padding: 16px;\n    width: 30%;\n    background: white;\n    box-shadow: 0px -2px 2px 0px #efefef;\n    margin: 0 5px 10px 0;\n    position: relative;\n    border-radius: 5px;\n    border: 1px solid orange;\n    gap: 10px;\n}\n\n .idle_reason_item h3 {\n    color: black;\n    margin: 0;\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 30px;\n}\n\n .idle_reason_item .machine_no {\n    color: #ccc;\n    position: absolute;\n    right: 10px;\n    bottom: 2px;\n    font-size: 20px;\n    font-weight: 400;\n}\n\n\n\nicon-text {\n    position: absolute;\n    top: 30%;\n    left: 50%;\n    transform: translateX(-50%);\n    font-size: 25px !important;\n    font-weight: 600;\n    color:black;\n}\n\n/* Responsive design */\n@media screen and (max-width: 768px) {\n    .container {\n        padding: 10px;\n        margin: 10px;\n    }\n\n    .idle_reason_item {\n        flex-direction: column;\n        align-items: flex-start;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
